import type { AppConfig } from "./types";

const development: AppConfig = {
  adobeFontsKitId: "nyi0urp",
  auth0ClientId: "aBJrVapq5D5WUy7Qg5ffdPvj65LAePqL",
  auth0CustomDomain: "auth.rtspro.dev",
  auth0Domain: "stc-development.us.auth0.com",
  enforceForthLeafAccess: true,
  featureServiceUrl: "https://feature-service.rtspro.dev/",
  forthLeafPermission: "internal.Admintools.User",
  usersServiceUrl: "https://sentinel-service.ryanrtsdev.com/user/",
};

export default development;
